import { Avatar, Dropdown, Grid, Space, Typography } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  IdcardOutlined,
  KeyOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants/routes';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const ROLE_LABELS: Record<string, string> = {
  owner: 'Chủ tiệm',
  manager: 'Quản lý',
  cashier: 'Thu ngân',
  inventory: 'Kho',
  viewer: 'Xem',
};

/**
 * User avatar + dropdown trên Header (EG-355 §4).
 * Items: Profile, Đổi mật khẩu, Đăng xuất.
 *
 * Mobile (<lg): chỉ hiện avatar (ẩn name/role text để tiết kiệm topbar space).
 */
export const HeaderUserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.lg;

  const items = [
    {
      key: 'profile',
      icon: <IdcardOutlined />,
      label: 'Hồ sơ',
      onClick: () => navigate(ROUTES.settings.profile),
    },
    {
      key: 'change-password',
      icon: <KeyOutlined />,
      label: 'Đổi mật khẩu',
      onClick: () => navigate(ROUTES.auth.changePassword),
    },
    { type: 'divider' as const },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Đăng xuất',
      danger: true,
      onClick: () => logout(),
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight" arrow trigger={['click']}>
      <Space size={8} style={{ cursor: 'pointer' }}>
        <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#a4193d' }} size="small" />
        {!isMobile && (
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
            <Text strong style={{ fontSize: 13 }}>
              {user?.name || 'Nhân viên'}
            </Text>
            <Text type="secondary" style={{ fontSize: 11 }}>
              {ROLE_LABELS[user?.role ?? ''] ?? user?.role}
            </Text>
          </div>
        )}
      </Space>
    </Dropdown>
  );
};
